import { Button, Grid, withStyles, FormControlLabel, Checkbox } from '@material-ui/core';
import { memo, useState } from 'react';
import { getEquipmentTypeOption } from '../../utils';
import SelectWithLabel from './SelectWithLabel';
import EquipmentUpdateWarning from './EquipmentUpdateWarning';
import {
  CheckBox as CheckBoxIcon,
  CheckBoxOutlineBlank as CheckBoxOutlineBlankIcon
} from '@material-ui/icons';
import { EQUIPMENT_FLOW } from '../../constants';
import styles from './styles';
import SectionHeader from '../SectionHeader';

const EquipmentDetails = ({
  classes,
  handleEquipmentTypeChange,
  equipmentDetails,
  handleEquipmentSizeChange,
  equipmentSizeOptions,
  errorInfo,
  enabledFixedEquipment,
  clearEquipmentPreference
}) => {
  const equipmentType = equipmentDetails.equipmentType;
  const equipmentConfig = equipmentDetails[equipmentType] || {};
  const [showFlexEquipmentSize, setShowFlexEquipmentSize] = useState(
    equipmentConfig.maxEquipmentSize || equipmentConfig.minEquipmentSize
  );
  const initialCheckedStatus = [
    equipmentConfig.maxEquipmentSize ? 'maxEquipmentSize' : null,
    equipmentConfig.minEquipmentSize ? 'minEquipmentSize' : null
  ].filter(Boolean);
  const [flexibleEquipCheckBox, setFlexibleEquipCheckBox] = useState({
    status: [
      { field: 'maxEquipmentSize', label: 'Max equipment size' },
      { field: 'minEquipmentSize', label: 'Min equipment size' }
    ],
    checkedStatus: initialCheckedStatus
  });

  const handleStatusChange = (field) => {
    const isChecked = flexibleEquipCheckBox.checkedStatus.includes(field);
    const updatedCheckedStatus = isChecked
      ? flexibleEquipCheckBox.checkedStatus.filter((checkedField) => checkedField !== field)
      : [...flexibleEquipCheckBox.checkedStatus, field];

    setFlexibleEquipCheckBox({ ...flexibleEquipCheckBox, checkedStatus: updatedCheckedStatus });
    handleEquipmentSizeChange(field)(null);
  };

  return (
    <div className={classes.container}>
      <SectionHeader
        title='Equipment'
        headerButtonDetails={{ label: 'Clear All', onClick: clearEquipmentPreference }}
      />
      <Grid container>
        <div className={classes.equipmentTypeContainer}>
          <Grid item xs={12}>
            <SelectWithLabel
              id="equipmentType"
              label="Use"
              data={getEquipmentTypeOption(enabledFixedEquipment)}
              onChange={handleEquipmentTypeChange}
              value={equipmentDetails.equipmentType}
              isNotClearable
            />
          </Grid>
          <span className={classes.equipmentLabel}>equipment.</span>
        </div>
        {equipmentDetails.equipmentType ? (
          <>
            {equipmentDetails.equipmentType === EQUIPMENT_FLOW.FIXED ? (
              <Grid className={classes.subHeading} item xs={12}>
                <SelectWithLabel
                  id="fixedEquipmentSize"
                  label="Equipment size:"
                  errorInfo={errorInfo}
                  value={equipmentDetails[equipmentDetails.equipmentType]?.fixedEquipmentSize ?? ''}
                  data={equipmentSizeOptions}
                  onChange={handleEquipmentSizeChange('fixedEquipmentSize')}
                />
                <EquipmentUpdateWarning equipmentType={equipmentDetails.equipmentType} />
              </Grid>
            ) : (
              <Grid className={classes.subHeading} item xs={12}>
                {showFlexEquipmentSize ? (
                  <>
                    <div className={classes.checkboxContainer}>
                      {flexibleEquipCheckBox.status.map((option) => {
                      const isChecked = flexibleEquipCheckBox.checkedStatus.includes(option.field);
                        return (
                        <div className={classes.checkboxSelect}>
                            <FormControlLabel
                              key={option.label}
                              control={
                                <Checkbox
                                  icon={<CheckBoxOutlineBlankIcon />}
                                  checkedIcon={<CheckBoxIcon />}
                                  classes={{
                                    root: classes.root,
                                    checked: classes.checked
                                  }}
                                />
                              }
                              label={`${option.label}${isChecked ? ':' : ''}`}
                              onChange={() => handleStatusChange(option.field)}
                              checked={isChecked}
                              classes={{ label: classes.checkBoxLabel }}
                              className={classes.checkBoxMargin}
                            />
                            {isChecked && (
                              <SelectWithLabel
                                id={option.field}
                                errorInfo={errorInfo}
                                value={
                                equipmentDetails[equipmentDetails.equipmentType]?.[option.field] ??
                                ''
                                }
                                data={equipmentSizeOptions}
                                onChange={handleEquipmentSizeChange(option.field)}
                              />
                            )}
                          </div>
                        );
                      })}
                    </div>
                    <EquipmentUpdateWarning equipmentType={equipmentDetails.equipmentType} />
                  </>
                ) : (
                  <Button
                    onClick={() => setShowFlexEquipmentSize(true)}
                    color="primary"
                    variant="text">
                    Add max/min equipment constraint
                  </Button>
                )}
              </Grid>
            )}
          </>
        ) : null}
      </Grid>
    </div>
  );
};

export default withStyles(styles)(memo(EquipmentDetails));
